import React from "react";
import {observer} from "mobx-react";
import css from './block1Card1.module.scss'
import classNames from "classnames";

const Index = ({children, className}) => {
    return (
        <div className={classNames(css.root, className)}>
            {children}
        </div>
    )
}

export default observer(Index)